import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Industry } from '../types/industry.types';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class IndustryService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  public searchIndustries(searchString: string) {
    return this.http.get<Industry[]>(
      environment.apiUrl + '/industries/?search_str=' + searchString + '&lang=' + this.translateService.getCurrentLang()
    );
  }

  public getAllIndustries() {
    return this.http.get<Industry[]>(environment.apiUrl + '/industries/');
  }
}
